/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import classNames from 'classnames';
import { useI18n } from 'nordic/i18n';
import { Button } from '@andes/button';
import { makeRedirection, trackAction } from '@/utils';
import SharedPropsContext from '../../../../../contexts/SharedProps';
import { getFooterSectionContent } from '../../content/footerSection';
import ArrowTop from './components/ArrowTop';

const FooterSection = () => {
  const {
    isMobile,
    isWebView,
    openSeaUrl,
    tracks,
    hasCreditLine,
    isYellowTheme,
  } = React.useContext(SharedPropsContext);
  const { i18n } = useI18n();

  const { title, subtitle, cta } = getFooterSectionContent({ i18n, hasCreditLine });

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const goToOpenSeaHandler = (e) => {
    e.preventDefault();

    const trackMelidata = {
      ...tracks.melidata.events.buyersPage.footerSection.goToOpenSea,
      event_data: {
        origin: 'footer',
      },
    };
    trackAction({
      melidata: trackMelidata,
    });

    makeRedirection({
      callback: openSeaUrl,
      isWebView,
    });
  };

  const footerContentClassNames = classNames(
    'footer-section__content',
    { 'footer-section__content-yellow': isYellowTheme },
  );

  const arrowTopClassNames = classNames(
    'footer-section__arrow-top-button',
    { 'footer-section__arrow-top-button-yellow': isYellowTheme },
  );

  return (
    <section className="footer-section">
      <div className="footer-section__button-container">
        <button
          className={arrowTopClassNames}
          onClick={scrollToTop}
          data-testid="go-to-top-button"
        >
          <ArrowTop />
        </button>
      </div>

      <div className={footerContentClassNames}>
        <h1 className="footer-section__title">{title}</h1>
        <h2 className="footer-section__subtitle">{subtitle}</h2>
        {cta
          && (
            <Button
              onClick={goToOpenSeaHandler}
              fullWidth={isMobile}
              data-testid="go-to-open-sea-button"
              className={!isYellowTheme && 'andes-button--white'}
            >
              {cta.text}
            </Button>
          )}
      </div>
    </section>
  );
};

export default FooterSection;
